import { FC } from "react";
import styles from "./TeamCard.module.scss";
import {
  HeadersOptionsType,
  TeamGridOptionsType,
} from "@/types/ModuleOptionsType";
import { MediaItem } from "../Global/MediaItem/MediaItem";
import ModalRoot from "../_primitives/Modal/ModalRoot/ModalRoot";
import ModalPortal from "../_primitives/Modal/ModalPortal/ModalPortal";
import ModalOverlay from "../_primitives/Modal/ModalOverlay/ModalOverlay";
import ModalContent from "../_primitives/Modal/ModalContent/ModalContent";
import { TeamModalContent } from "../TeamModalContent/TeamModalContent";
import { OptionsSocialMediaType } from "@/types/OptionType";
import { ModalClose } from "../_primitives/Modal/ModalClose/ModalClose";
import { Post } from "@/wp/types/client";
import { useTeamCard } from "./useTeamCard";
import { Modul_Mitarbeiter_Grid } from "@/wp/types/acf-module-types";

export type TeamCardElementType = {
  element: Post<"team">["acf"]["header_team"];
  url: string;
};

interface TeamCardProps {
  team: TeamCardElementType;
  gridOptions: TeamGridOptionsType;
  socialMedia: OptionsSocialMediaType;
  teamheaderOptions: HeadersOptionsType["header_team"];
  headlineTag: Modul_Mitarbeiter_Grid["team_grid"]["headline_html_tag"];
}

export const TeamCard: FC<TeamCardProps> = ({
  team,
  gridOptions,
  socialMedia,
  teamheaderOptions,
  headlineTag,
}) => {
  const { element } = team;
  const {
    grid_options: { grid_type, team_item_view },
    media_format,
  } = gridOptions;
  const { cardClassName, LinkJSX, NameJSX, link } = useTeamCard(
    gridOptions,
    team,
    headlineTag,
  );

  const isTitleInImage = grid_type === "title-in-image";
  const isSingleViewOrPopUp =
    team_item_view === "single-view" || team_item_view === "pop-up";

  const CardJSX = (
    <article className={cardClassName}>
      <MediaItem
        image_desktop={element.image}
        mediaFormat={media_format}
        sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
        copyrightPosition={grid_type === "title-in-image" ? "top" : "bottom"}
        disableIsSVG
        link={isSingleViewOrPopUp && element.has_single_page ? link : undefined}
      />

      {isTitleInImage ? (
        <>
          {isSingleViewOrPopUp && LinkJSX}
          <div className={styles["abs-wrapper"]}>{NameJSX}</div>
        </>
      ) : (
        <div className={styles["team-card-content"]}>
          <div>
            {NameJSX}
            <p className={styles["position"]}>{element.position}</p>
          </div>
          {isSingleViewOrPopUp && LinkJSX}
        </div>
      )}
    </article>
  );

  if (team_item_view === "single-view") return CardJSX;

  return (
    <ModalRoot>
      {CardJSX}
      <ModalPortal>
        <ModalOverlay />
        <ModalContent>
          <ModalClose></ModalClose>
          <TeamModalContent
            team={team}
            socialMedia={socialMedia}
            teamheaderOptions={teamheaderOptions}
          />
        </ModalContent>
      </ModalPortal>
    </ModalRoot>
  );
};
